var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 0.666992H2.83309C1.27476 0.666992 0.0139225 1.94199 0.0139225 3.50033L-0.000244141 20.5003C-0.000244141 22.0587 1.27476 23.3337 2.83309 23.3337H25.4998C27.0581 23.3337 28.3331 22.0587 28.3331 20.5003V3.50033C28.3331 1.94199 27.0581 0.666992 25.4998 0.666992ZM25.4998 20.5003H2.83309V6.33366L14.1664 13.417L25.4998 6.33366V20.5003ZM14.1664 10.5837L2.83309 3.50033H25.4998L14.1664 10.5837Z",
    fill: "#217C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.72201ac55cf6f6d2cd205908a3d7297c.svg";
export { ForwardRef as ReactComponent };